import AustraliaFlag from "../../images/Australian-flag.svg";
import AmericaFlag from "../../images/American-flag.svg";
import IndiaFlag from "../../images/Indian-flag.svg";
import linkedinIcon from "../../images/linkedin.svg";
import facebookIcon from "../../images/fb.svg";
import instagramIcon from "../../images/instagram.svg";
import youtubeIcon from "../../images/youtube.svg";

export const AusFlag = AustraliaFlag;
export const USAFlag = AmericaFlag;
export const IndianFlag = IndiaFlag;
export const linkedin = linkedinIcon;
export const facebook = facebookIcon;
export const instagram = instagramIcon;
export const youtube = youtubeIcon;
